import { reactive } from 'vue'
import store from './store'
import { createLoading } from './utils/loading'
import i18n from './i18n'
import enUS from "ant-design-vue/lib/locale-provider/en_US";
import thTH from "ant-design-vue/lib/locale-provider/th_TH";
import { randomUuid } from './utils/util';
import lodash from 'lodash'
import websocket from "./utils/websocket";
import moment from 'moment';
import 'moment/locale/th'

export const { isLoading, setIsLoading } = createLoading()

export const setLocale = (locale) => {
    localStorage.setItem('locale', locale)
    state.locale = locale
    i18n.global.locale = locale
    moment.locale(locale)
}

export const getConfigProviderLocale = () => {
    if (state.locale === "th") {
        return thTH;
    }
    return enUS;
}

export const getBrandUrl = () => {
    const brand = store.state.resource.server.info?.brand;
    if (!brand) {
        return null
    }
    return `${process.env.VUE_APP_API_URL}${brand}?timestamp=${new Date().getTime()}`
}

export const getLogoUrl = () => {
    const logo = store.state.resource.server.info?.logo;
    if (!logo) {
        return null
    }
    return `${process.env.VUE_APP_API_URL}${logo}?timestamp=${new Date().getTime()}`
}

export const getFavicon = () => {
    const favicon = store.state.resource.server.info?.favicon;
    if (!favicon) {
        return null
    }
    return `${process.env.VUE_APP_API_URL}${favicon}?timestamp=${new Date().getTime()}`
}

export const addModal = ({ bind, render }) => {
    const options = reactive({
        id: randomUuid(),
        bind: {
            visible: true,
            onCancel: () => removeModal({ options }),
        },
    })
    lodash.merge(
        options,
        {
            bind,
            render
        }
    )
    state.modals.push(options)
    return options
}

export const removeModal = ({ options }) => {
    if (!options) {
        return
    }
    options.bind.visible = false
    setTimeout(() => state.modals = state.modals.filter(modal => modal.id !== options.id), 2000);
}

export const clearModal = () => {
    state.modals.forEach(options => removeModal({ options }))
}

export const state = reactive({
    authInfo: null,
    menuContext: null,
    isChangePage: false,
    locale: null,
    localeInterval: null,
    modals: [],
    websocketId: null,
    websocketSubscribes: [],
})

if (window.serverInfo) {
    store.commit("resource/server/setInfo", lodash.cloneDeep(window.serverInfo));
} else {
    store.dispatch("resource/server/getInfo", {});
}

if (window.authInfo) {
    store.commit("resource/auth/setInfo", lodash.cloneDeep(window.authInfo));
}

setLocale(localStorage.getItem('locale') || process.env.VUE_APP_DEFAULT_LANG)

const onWebsocketConnect = () => {
    state.websocketSubscribes.push(websocket.subscribe(`/topic/auth/getInfo`, () => {
        const isAuth = store.getters['resource/auth/isAuth']
        if (isAuth) {
            store.dispatch('resource/auth/getInfo', { options: { force: true } })
        } else {
            store.dispatch('resource/anonymous/getInfo', { options: { force: true } })
        }
    }));
}
const uri = window.location.search.substring(1);
const params = new URLSearchParams(uri);
if (params.get("canSelect") !== 'true') {
    state.websocketId = websocket.connect(onWebsocketConnect, null, { force: true });
}
